export function prepareSchedule({
    monday,
    tuesday,
    wednesday,
    thursday,
    friday,
    saturday,
    sunday,
    fromDate,
    toDate,
    ...schedule
}) {
    return {
        days: Object.entries({
            monday,
            tuesday,
            wednesday,
            thursday,
            friday,
            saturday,
            sunday
        }).reduce(
            (result, [key, val]) => val
                ? [...result, key]
                : result,
            []
        ),
        isEveryDay: monday && tuesday && wednesday && thursday && friday && saturday && sunday,
        fromDate: fromDate ? new Date(fromDate) : null,
        toDate: toDate ? new Date(toDate) : null,
        ...schedule
    };
}
